import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

// Màn công khai: KHÔNG khai `onlyGuest` lẫn `requireAuth`. User đang đăng nhập trên máy này vẫn có
// quyền quên mật khẩu (đăng nhập bằng Google, hoặc phiên còn sống từ lần trước).
export const forgotPasswordRoutes = {
  name: 'forgot-password',
  path: 'forgot-password',
  components: {
    default: () => import('./ForgotPassword.vue'),
    brand: () => import('./ForgotPasswordBrand.vue'),
  },
  meta: {
    i18n,
    authHeader: { titleKey: 'forgotPassword.heading', subtitleKey: 'forgotPassword.desc' },
  },
} satisfies RouteRecordRaw;
